import { Component, OnInit } from '@angular/core';
import { CurrencyPipe, DatePipe, NgFor } from '@angular/common';
import { IPayments } from '../../interfaces/payments';
import { Payments } from '../../classes/payments';

@Component({
  selector: 'app-payment-details',
  standalone: true,
  imports: [DatePipe, CurrencyPipe, NgFor],
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.css'
})
export class PaymentDetailsComponent implements OnInit {

  paymentsArray: IPayments[] = [];
  paymentsInterface: IPayments;
  constructor(private payments: Payments, private datePipe: DatePipe, private currencyPipe: CurrencyPipe) { }
  ngOnInit(): void {
    const paymentResponses = this.payments.getPayments()?.length ? this.payments.getPayments() : [{}]
    for (let payment of paymentResponses) {
      this.paymentsInterface = {
        index: payment.payment_index ? payment.payment_index : "",
        paymentNumber: payment.payment_number ? payment.payment_number : 'Not Available',
        paymentDate: payment.payment_date ? this.datePipe.transform(payment.payment_date, 'MM-dd-YYYY') : 'Not Available',
        payee: payment.payee ? payment.payee : 'Not Available',
        amount: payment.amount ? this.currencyPipe.transform(payment.amount, 'USD') : 'Not Available',
        method: payment.method ? payment.method : 'Not Available',
        status: payment.status ? payment.status : 'Not Available',
        reference_num: payment.reference_num ? payment.reference_num : 'Not Available'
      }
      this.paymentsArray.push(this.paymentsInterface)
    }
  }
}
